import React, { Fragment, useEffect, useState } from "react";
import { Col, Card, Dropdown } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import Pagination from "@mui/material/Pagination";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import * as constants from "../../../utils/Constants";
import { toast, ToastContainer } from "react-toastify";

const ViewRecruitingAgents = () => {
  const { state } = useLocation();
  const location = useLocation();
  const [page, setPage] = useState(
    Number(location?.pageCallBack) > 1 ? Number(location?.pageCallBack) : 1
  );
  const [pageDetails, setPageDetails] = useState({});
  const [keyAccountManager, setKeyAccountManager] = useState([]);
  const [sortBy, setSortBy] = useState(location?.sortByCallBack);
  const [order, setOrder] = useState(location?.orderCallBack);
  const [isLoaded, setIsLoaded] = useState(false);
  const history = useHistory();
  const [searchText, setSearchText] = useState(location?.searchCallBack);
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  const [agentData, setAgentData] = useState([]);

  function getAllRecruitingAgents(page, search, sort, order) {
    fetch(
      `${constants.ListRecruitingAgentsUrl}?page=${page}&search=${
        search || ""
      }&sortBy=${sort || ""}&sort=${order || ""}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        body: JSON.stringify(filterData || {}),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setAgentData(result?.data?.content);
          setPageDetails(result?.data);
          setData(document.querySelectorAll("#application tbody tr"));
        },
        (error) => {
          setIsLoaded(true);
          console.log(error);
        }
      );
  }

  const handlePageChange = (event, value) => {
    setPage(value);
    getAllRecruitingAgents(value - 1, searchText, sortBy, order);
  };

  //popup filter
  const openFilter2 = () => {
    document.getElementById("staticBackdrop").style.display = "none";
  };
  const clearFilter = () => {
    window.location.reload();
  };
  const openFilter = () => {
    document.getElementById("staticBackdrop").style.top =
      document.getElementById("popupbox").getBoundingClientRect().y + 20 + "px";
    document.getElementById("staticBackdrop").style.left =
      document.getElementById("popupbox").getBoundingClientRect().x -
      310 +
      "px";
    document.getElementById("staticBackdrop").style.display = "block";
    if (openFilterClicked) {
      openFilter2();
      openFilterClicked = false;
    } else {
      openFilterClicked = true;
    }
  };
  var openFilterClicked = false;

  //  Filter Dropdown
  const [filterData, setFilterData] = useState({
    ...state,
    ...location?.filterDataCallback,
  });
  const [status, setStatus] = useState([]);

  const statusOptions = () => {
    return status.map((keys) => ({
      label: keys.statusName,
      value: keys.statusName,
    }));
  };

  const handleStatus = (value) => {
    const newLoginData = { ...filterData };
    let statusChange = new Array();
    if (value) {
      for (var i = 0; i < value.length; i++) {
        statusChange.push(value[i].value.toString());
      }
      newLoginData["agentStatus"] = statusChange;
    } else {
      statusChange.length = 0;
      newLoginData["agentStatus"] = statusChange;
    }
    setFilterData(newLoginData);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllRecruitingAgents(page - 1, searchText, sortBy, order);
    handleGetKeyAccountManager();
    fetch(constants.RecruitingAgentStatusUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setStatus(result.data);
      });
  }, []);

  useEffect(() => {
    handleSearch(searchText);
  }, [searchText]);

  //Filter
  const handleFilter = () => {
    if (filterData)
      document.getElementById("staticBackdrop").style.display = "none";
    if (location?.pageCallBack) {
      getAllRecruitingAgents(page - 1, searchText, sortBy, order);
    } else {
      setPage(1);
      getAllRecruitingAgents(0, searchText, sortBy, order);
    }
  };

  const handleRowClick = (selectedRow) => {
    history.push({
      pathname: "/agent-profile",
      state: selectedRow,
      filterDataCallback: filterData,
      searchCallBack: searchText,
      sortByCallBack: sortBy,
      orderCallBack: order,
      pageCallBack: page,
    });
  };

  const handleGetKeyAccountManager = () => {
    fetch(constants.KeyAccountManagerGetUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setKeyAccountManager(result.data);
      });
  };

  const handleApproval = (selectedRow) => {
    fetch(`${constants.ApproveOrRejectAgentUrl}/${selectedRow.agentId}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify({ agentStatus: "Approved" }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res?.message) {
          fetch(constants.ListRecruitingAgentsUrl, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${loggedInUser.sessionToken}`,
            },
          })
            .then((res) => res.json())
            .then(
              (result) => {
                setIsLoaded(true);
                setAgentData(result.data);
                setData(document.querySelectorAll("#application tbody tr"));
              },
              (error) => {
                setIsLoaded(true);
                console.log(error);
              }
            );
        }
      });
  };

  const handleRejection = (selectedRow) => {
    fetch(`${constants.ApproveOrRejectAgentUrl}/${selectedRow.agentId}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify({ agentStatus: "Rejected" }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res?.message) {
          fetch(constants.ListRecruitingAgentsUrl, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${loggedInUser.sessionToken}`,
            },
          })
            .then((res) => res.json())
            .then(
              (result) => {
                setIsLoaded(true);
                setAgentData(result.data);
                setData(document.querySelectorAll("#application tbody tr"));
              },
              (error) => {
                setIsLoaded(true);
                console.log(error);
              }
            );
        }
      });
  };

  const handleAssignChange = (agentId, assignId) => {
    const selectedManager = keyAccountManager.find(
      (manager) => manager.id === assignId
    );

    fetch(`${constants.AdminAssignAgentUrl}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify({ agentId, keyAccountManagerId: assignId }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.message) {
          if (res.message.messageCode) {
            toast.success(`✅ ${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });

            const updatedAgentData = agentData?.map((agent) =>
              agent.agentId === agentId
                ? { ...agent, keyAccountManagerName: selectedManager.name }
                : agent
            );
            setAgentData(updatedAgentData);
          }
        } else if (res.error) {
          if (res.error.errorCode) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
        }
      });
  };

  const handleSortOntable = (key, order) => {
    setSortBy(key);
    setOrder(order);
    if (location?.pageCallBack) {
      getAllRecruitingAgents(page - 1, searchText, key, order);
    } else {
      setPage(1);
      getAllRecruitingAgents(0, searchText, key, order);
    }
  };

  const handleSearch = (search) => {
    if (location?.pageCallBack) {
      getAllRecruitingAgents(page - 1, search || searchText, sortBy, order);
    } else {
      setPage(1);
      getAllRecruitingAgents(0, search || searchText, sortBy, order);
    }
  };

  const [data, setData] = useState(
    document.querySelectorAll("#application tbody tr")
  );

  const [test, settest] = useState(0);

  // use effect
  useEffect(() => {
    setData(document.querySelectorAll("#application tbody tr"));
    chackboxFun();
  }, [test]);

  const chackbox = document.querySelectorAll(".application_sorting_1 input");
  const motherChackBox = document.querySelector("#checkAll");

  const chackboxFun = (type) => {
    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === "all") {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };

  return (
    <Fragment>
      <div className="d-flex flex-wrap mb-4">
        <div className="mr-auto mb-2 pr-2 show-results">
          <h6 className="text-black fs-16 font-w600 mb-1">
            Showing {pageDetails?.totalElements} Recruiting Agents Results
          </h6>
          <span className="fs-14">Based your preferences</span>
        </div>
        <div className="d-flex flex-wrap mb-l3 mb-s1">
          <div className="input-group search-area d-xl-inline-flex">
            <input
              type="text"
              onChange={(e) => setSearchText(e.target.value)}
              value={searchText}
              className="form-control"
              placeholder="Search here..."
            />
            <div className="input-group-append">
              <span className="input-group-text">
                <i
                  className="flaticon-381-search-2"
                  onClick={handleSearch}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
          </div>
        </div>
        &nbsp;&nbsp;
        {/* Filter */}
        <div className="d-flex flex-wrap mb-3">
          <div>
            <div className="dropdown custom-dropdown mb-0 mt-3 mt-sm-0 mb-1">
              <button
                className="btn btn-primary btn-primary"
                id="popupbox"
                onClick={openFilter}
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="18"
                  fill="currentColor"
                  className="bi bi-filter-square"
                  viewBox="0 0 16 16"
                >
                  {" "}
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />{" "}
                  <path d="M6 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" />{" "}
                </svg>{" "}
                Filter
              </button>
              {/* popup */}
              <div>
                <div
                  className="modal fade show"
                  id="staticBackdrop"
                  style={{ width: "400px", height: "63%", top: 100, left: 503 }}
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabIndex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div
                        className=""
                        style={{
                          overflowY: "scroll",
                          width: "400px",
                          height: "250px",
                        }}
                      >
                        <div>
                          {/* className="modal-header" */}
                          <Col lg={12}>
                            <Card>
                              <Card.Body>
                                <h4>
                                  <b>Filter Job</b>
                                </h4>
                                <br></br>
                                <div form-group row>
                                  <ReactMultiSelectCheckboxes
                                    placeholderButtonLabel="Status"
                                    isMulti
                                    options={statusOptions()}
                                    onChange={(value) => {
                                      handleStatus(value);
                                    }}
                                  />
                                </div>
                                <br></br>
                                <br></br>
                                <div>
                                  <button
                                    type="button"
                                    onClick={clearFilter}
                                    className="btn btn-primary"
                                  >
                                    Clear
                                  </button>
                                  &nbsp;&nbsp;
                                  <button
                                    type="button"
                                    onClick={handleFilter}
                                    className="btn btn-primary"
                                  >
                                    Apply
                                  </button>
                                  &nbsp;&nbsp;
                                </div>
                                <br></br>
                              </Card.Body>
                            </Card>
                          </Col>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        &nbsp;&nbsp;
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <div id="application" className="dataTables_wrapper no-footer">
              {!isLoaded ? (
                <div>
                  <Box className="card" sx={{ width: "100%" }}>
                    <LinearProgress />
                  </Box>
                </div>
              ) : agentData?.length <= 0 ? (
                <div>No records found</div>
              ) : (
                <table
                  className="table display mb-4 dataTablesCard table-responsive-xl card-table dataTable no-footer"
                  id="example5"
                >
                  <thead>
                    <tr role="row">
                      <th className="sorting" style={{ width: "100px" }}>
                        <div
                          className="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Name </span>
                          <div
                            className="alignCenter"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              className="fa fa-sort-asc"
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("agentName", "asc");
                              }}
                            ></i>
                            <i
                              className="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("agentName", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      <th className="sorting" style={{ width: "100px" }}>
                        <div
                          className="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Agent Code</span>
                          <div
                            className="alignCenter"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              className="fa fa-sort-asc "
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("agentCode", "asc");
                              }}
                            ></i>
                            <i
                              className="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("agentCode", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      <th className="sorting">Email Id</th>
                      <th className="sorting">Mobile Number</th>
                      {loggedInUser?.roles === "Admin" && (
                        <th className="sorting" style={{ width: "100px" }}>
                          <div
                            className="row"
                            style={{
                              flexWrap: "unset",
                              justifyContent: "center",
                            }}
                          >
                            <span>Status</span>
                            <div
                              className="alignCenter"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "20px",
                                marginLeft: "10px",
                                alignItems: "flex-start",
                              }}
                            >
                              <i
                                className="fa fa-sort-asc "
                                style={{
                                  padding: "0px",
                                  height: "8px",
                                  marginTop: "3px",
                                }}
                                type="button"
                                onClick={() => {
                                  handleSortOntable("agentStatus", "asc");
                                }}
                              ></i>
                              <i
                                className="fa fa-sort-desc"
                                style={{ height: "8px", marginTop: "-3px" }}
                                type="button"
                                onClick={() => {
                                  handleSortOntable("agentStatus", "desc");
                                }}
                              ></i>
                            </div>
                          </div>
                        </th>
                      )}
                      <th className="sorting">Aadhar Number</th>
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          className="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>PAN</span>
                          <div
                            className="alignCenter"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              className="fa fa-sort-asc "
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("panCard", "asc");
                              }}
                            ></i>
                            <i
                              className="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("panCard", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          className="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Agreement</span>
                          <div
                            className="alignCenter"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              className="fa fa-sort-asc "
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("agreementStatus", "asc");
                              }}
                            ></i>
                            <i
                              className="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("agreementStatus", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      {loggedInUser?.roles === "Admin" && (
                        <th className="sorting">Assign to</th>
                      )}
                      {loggedInUser?.roles === "Admin" && (
                        <th className="sorting">Action</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {agentData?.map((candidate) => {
                      return (
                        <tr
                          role="row"
                          style={{
                            cursor: "pointer",
                          }}
                          className="odd"
                        >
                          <td onClick={() => handleRowClick(candidate)}>
                            {candidate.agentName}
                          </td>
                          <td onClick={() => handleRowClick(candidate)}>
                            {candidate.agentCode}
                          </td>
                          <td onClick={() => handleRowClick(candidate)}>
                            {candidate.emailId}
                          </td>
                          <td onClick={() => handleRowClick(candidate)}>
                            {candidate.mobileNumber}
                          </td>
                          {loggedInUser?.roles === "Admin" && (
                            <td onClick={() => handleRowClick(candidate)}>
                              <div>
                                <button
                                  style={{
                                    border: "none",
                                    padding: "5px 10px",
                                    backgroundColor:
                                      candidate.agentStatus === "Unverified"
                                        ? "Blue"
                                        : candidate.agentStatus === "Accepted"
                                        ? "Green"
                                        : candidate.agentStatus === "Approved"
                                        ? "#FFCA2C"
                                        : "Red",
                                    textAlign: "center",
                                  }}
                                  type="button"
                                  className="btn btn-primary btn-md"
                                >
                                  {candidate?.agentStatus}
                                </button>
                              </div>
                            </td>
                          )}
                          <td onClick={() => handleRowClick(candidate)}>
                            {candidate.aadharCard}
                          </td>
                          <td onClick={() => handleRowClick(candidate)}>
                            {candidate.panCard}
                          </td>
                          <td onClick={() => handleRowClick(candidate)}>
                            {candidate.agreementStatus}
                          </td>
                          {loggedInUser?.roles === "Admin" && (
                            <td>
                              <div className="d-flex align-items-center">
                                <Dropdown className="dropdown float-right custom-dropdown mb-0">
                                  <Dropdown.Toggle
                                    className="i-false"
                                    data-toggle="dropdown"
                                    variant=""
                                  >
                                    {candidate.keyAccountManagerName} &nbsp;
                                    &nbsp;
                                    <i className="fa fa-edit mr-1" />
                                    {/* <svg
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                      stroke="#2E2E2E"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                      stroke="#2E2E2E"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                      stroke="#2E2E2E"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg> */}
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu className="dropdown-menu dropdown-menu-right">
                                    {keyAccountManager?.map((manager, index) => (
                                      <Dropdown.Item
                                        className="dropdown-item"
                                        //   onClick={() => handleRejection(candidate)}
                                        onClick={() =>
                                          handleAssignChange(
                                            candidate.agentId,
                                            manager.id
                                          )
                                        }
                                      >
                                        {manager.employeeId} - {manager.name}
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </td>
                          )}
                          {loggedInUser?.roles === "Admin" && (
                            <td>
                              <div className="d-flex align-items-center">
                                <Dropdown className="dropdown float-right custom-dropdown mb-0">
                                  <Dropdown.Toggle
                                    className="i-false"
                                    data-toggle="dropdown"
                                    variant=""
                                  >
                                    <svg
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                        stroke="#2E2E2E"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                        stroke="#2E2E2E"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                        stroke="#2E2E2E"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu className="dropdown-menu dropdown-menu-right">
                                    {candidate.agentStatus === "Unverified" &&
                                      candidate.agreementStatus ===
                                        "Uploaded" && (
                                        <Dropdown.Item
                                          className="dropdown-item"
                                          onClick={() =>
                                            handleApproval(candidate)
                                          }
                                        >
                                          Approve
                                        </Dropdown.Item>
                                      )}
                                    <Dropdown.Item
                                      className="dropdown-item"
                                      onClick={() => handleRejection(candidate)}
                                    >
                                      Reject
                                    </Dropdown.Item>
                                    <Dropdown.Item className="dropdown-item text-danger">
                                      Cancel
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                <div className="dataTables_info" id="example5_info">
                  Page: {page}
                </div>
                <div>
                  <Pagination
                    count={pageDetails?.totalPages}
                    page={page}
                    onChange={handlePageChange}
                  />
                </div>
              </div>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ViewRecruitingAgents;
